export default __webpack_public_path__ + "static/media/image_service_bg@2x.1871fafe.png";